import $ from 'jquery';

export default class SearchBar {
    constructor() {
        $('.js-header__search-trigger').on('click', function() {
            $(this).toggleClass('is-active');
            $('.js-header__search-trigger-icon').toggleClass('icon-search icon-close-icon');

            $('.js-search').slideToggle();
        });
    };
};
